import type { Org } from '../../app/core/orgs/org.types';

export const MOCK_ORGS: Org[] = [
  {
    id: 'acme', name: 'Acme Industries', slug: 'acme', plan: 'growth', status: 'ACTIVE',
    role: 'org_owner', countryCode: 'US', tier: 'Growth · US', memberCount: 487, initials: 'AI',
    description: 'Global manufacturer; piloting the Klaro suite for ops + finance.',
    industry: 'Manufacturing', sizeBand: '201-1000', baseLanguage: 'en-US',
    baseTimezone: 'America/New_York', baseCurrency: 'USD', fiscalYearStart: '2024-01-01',
    createdAt: '2024-01-15T10:00:00-05:00',
  },
  {
    id: 'brava', name: 'Brava GmbH', slug: 'brava', plan: 'starter', status: 'ACTIVE',
    role: 'org_admin', countryCode: 'DE', tier: 'Starter · DE', memberCount: 142, initials: 'BG',
    description: 'EU SaaS company — uses Klaro for HR + billing in DE/FR.',
    industry: 'SaaS', sizeBand: '51-200', baseLanguage: 'de-DE',
    baseTimezone: 'Europe/Berlin', baseCurrency: 'EUR', fiscalYearStart: '2024-01-01',
    createdAt: '2024-02-20T09:00:00+01:00',
  },
  {
    id: 'kumar', name: 'Kumar & Co', slug: 'kumar', plan: 'starter', status: 'ACTIVE',
    role: 'org_member', countryCode: 'IN', tier: 'Starter · IN', memberCount: 28, initials: 'KC',
    description: 'India accounting practice; primary user of Klaro Books with GST.',
    industry: 'Professional Services', sizeBand: '11-50', baseLanguage: 'en-IN',
    baseTimezone: 'Asia/Kolkata', baseCurrency: 'INR', fiscalYearStart: '2024-04-01',
    createdAt: '2024-03-30T09:30:00+05:30',
  },
  {
    id: 'acme-eu', name: 'Acme EU', slug: 'acme-eu', plan: 'growth', status: 'TRIAL',
    role: 'org_admin', countryCode: 'IE', tier: 'Trial · EU', memberCount: 156, initials: 'AE',
    description: "Acme's European subsidiary — same parent, separate residency.",
    industry: 'Manufacturing', sizeBand: '51-200', baseLanguage: 'en-GB',
    baseTimezone: 'Europe/Dublin', baseCurrency: 'EUR', fiscalYearStart: '2024-01-01',
    createdAt: '2026-04-01T10:00:00+01:00', trialEndsAt: '2026-05-01T10:00:00+01:00',
  },
];

export function findOrg(id: string): Org | null {
  return MOCK_ORGS.find((o) => o.id === id || o.slug === id) ?? null;
}
